import { render, staticRenderFns } from "./TabInfo.vue?vue&type=template&id=6e485c2d&scoped=true&"
import script from "./TabInfo.vue?vue&type=script&lang=js&"
export * from "./TabInfo.vue?vue&type=script&lang=js&"
import style0 from "./TabInfo.vue?vue&type=style&index=0&id=6e485c2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e485c2d",
  null
  
)

export default component.exports